<div id="invalidStatePopup" class="invalid-state-popup {{ additionalClasses }}">
    <div class="cont">
        <div class="invImgDiv">
            <img src="../../../../../assets/images/invalid-state-img.svg" loading="lazy"/>
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.state) && !isBlocked">
            We currently do not offer<br /> loans in your state.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.address) && !isBlocked">
            Please enter a valid address.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.ssn_dob) && !isBlocked">
            Re-enter your 9-digit Soc. Sec. #<br /> and your Date of Birth.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.dob) && !isBlocked">
            Re-enter your Date of Birth.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.ssn) && !isBlocked">
            Re-enter your 9-digit Soc. Sec. #<br /> and your Date of Birth.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.mobile) && !isBlocked">
            A valid mobile number is required<br /> to advance your loan application.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.isBlockedById) && !isBlocked">
            We're unable to process this<br /> application. Please try again later.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.preApproved)">
            Your loan request was pre-approved <br>up to {{amountValue}}.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.lessStateAmount) || typeIs(_UserStateType.lessStateAmountAfter)">
            The minimum loan amount is {{modalPopups.hawaiiMinAmount}}<br>for Hawaii loan applications.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.minRequiredAmount)">
            The entered loan amount must be<br>at least {{modalPopups.requiredMinAmount}}.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.maxLoanAmount)">
            Max loan amount is {{modalPopups.loanMaxAmount}}.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.minLoanAmount)">
            The entered loan amount must be<br>at least {{modalPopups.loanMinAmount}}.
        </div>
        <div class="botTextState" *ngIf="typeIs(_UserStateType.noSelectedDentist)">
            Please make your selection<br>to advance.
        </div>
        <div class="botTextState" *ngIf="isBlocked">
            We're unable to process this<br /> application. Please try again later.
        </div>
    </div>
</div>